import { GOI_SERVICE_URL } from "@/constants/url";
import { ColorIcon, HStack, NextLink, VStack, queryKeys } from "goi_common";
import ReviewItem from "./ReviewItem";
import { useQuery } from "react-query";
import { getSangjoReviews } from "@/apis/sangjoReview";

const CustomerReview = () => {
  const { data } = useQuery(queryKeys.sangjoReviews, () =>
    getSangjoReviews({ is_best_review: true }),
  );

  return (
    <VStack
      as="section"
      gap="8px"
      css={{
        marginTop: "40px",
      }}
    >
      <HStack className="white" alignItems="center" justifyContent="space-between">
        <span className="subtitle_18_sb">고객 후기</span>
        <NextLink href={`${GOI_SERVICE_URL}/review`}>
          <HStack gap="2px" alignItems="center">
            <span>후기 전체 보기</span>
            <ColorIcon name="icon-arrow-right-small-mono" size={12} color="white" />
          </HStack>
        </NextLink>
      </HStack>
      {data && (
        <ul>
          {data.results.map((review) => (
            <ReviewItem review={review} key={review.id} />
          ))}
        </ul>
      )}
    </VStack>
  );
};

export default CustomerReview;
